import { render } from "./ReportOpenedDebits.vue?vue&type=template&id=48a29974"
import script from "./ReportOpenedDebits.vue?vue&type=script&lang=js"
export * from "./ReportOpenedDebits.vue?vue&type=script&lang=js"

import "./ReportOpenedDebits.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__